module.exports = __webpack_public_path__ + "img/sandwich.be5030ca.webp";